const BubbleConfigHintImage = () => {
  return (
    <svg width="156" height="140" viewBox="0 0 156 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3361_120304)">
        <path
          d="M-82.8189 0.427684C-82.8189 -3.02208 -80.0223 -5.81865 -76.5726 -5.81865H104.612C108.061 -5.81865 110.858 -3.02207 110.858 0.42769V124.013C110.858 124.42 110.528 124.75 110.121 124.75H-82.082C-82.489 124.75 -82.8189 124.42 -82.8189 124.013V0.427684Z"
          fill="#1C1C21"
          stroke="#1C1C21"
          strokeWidth="0.362691"
        />
        <path
          d="M-83.0002 0.050324C-83.0002 -2.73889 -80.7391 -5 -77.9499 -5H104.449C107.239 -5 109.5 -2.73889 109.5 0.0503273V120H-83.0002V0.050324Z"
          fill="#F3F4FC"
        />
        <g opacity="0.7">
          <rect x="42.4065" y="22.3008" width="44.9737" height="25.3884" rx="2.17615" fill="#E7E9F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.2892 31.915C67.6657 31.915 67.9738 32.2231 67.9738 32.5996V37.3915C67.9738 37.768 67.6657 38.0761 67.2892 38.0761H62.4973C62.1208 38.0761 61.8127 37.768 61.8127 37.3915V32.5996C61.8127 32.2231 62.1208 31.915 62.4973 31.915H67.2892ZM64.551 36.5392L63.6953 35.509L62.4973 37.0492H67.2892L65.749 34.9956L64.551 36.5392Z"
            fill="#F3F4FC"
          />
          <rect x="42.4065" y="51.3164" width="44.9737" height="3.62691" rx="1.81345" fill="#E7E9F9" />
          <rect x="42.4065" y="57.1191" width="31.3186" height="3.62691" rx="1.81345" fill="#E7E9F9" />
        </g>
        <g opacity="0.7">
          <rect x="-14.5359" y="69.4512" width="44.9737" height="25.3884" rx="2.17615" fill="#E7E9F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3468 79.0645C10.7233 79.0645 11.0314 79.3725 11.0314 79.749V84.5409C11.0314 84.9174 10.7233 85.2255 10.3468 85.2255H5.55492C5.17841 85.2255 4.87036 84.9174 4.87036 84.5409V79.749C4.87036 79.3725 5.17841 79.0645 5.55492 79.0645H10.3468ZM7.6086 83.6887L6.7529 82.6584L5.55492 84.1986H10.3468L8.80658 82.145L7.6086 83.6887Z"
            fill="#F3F4FC"
          />
          <rect x="-14.5359" y="98.4668" width="44.9737" height="3.62691" rx="1.81345" fill="#E7E9F9" />
          <rect x="-14.5359" y="104.27" width="31.3186" height="3.62691" rx="1.81345" fill="#E7E9F9" />
        </g>
        <g opacity="0.7">
          <rect x="42.4065" y="69.4512" width="44.9737" height="25.3884" rx="2.17615" fill="#E7E9F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.2892 79.0645C67.6657 79.0645 67.9738 79.3725 67.9738 79.749V84.5409C67.9738 84.9174 67.6657 85.2255 67.2892 85.2255H62.4973C62.1208 85.2255 61.8127 84.9174 61.8127 84.5409V79.749C61.8127 79.3725 62.1208 79.0645 62.4973 79.0645H67.2892ZM64.551 83.6887L63.6953 82.6584L62.4973 84.1986H67.2892L65.749 82.145L64.551 83.6887Z"
            fill="#F3F4FC"
          />
          <rect x="42.4065" y="98.4668" width="44.9737" height="3.62691" rx="1.81345" fill="#E7E9F9" />
          <rect x="42.4065" y="104.27" width="31.3186" height="3.62691" rx="1.81345" fill="#E7E9F9" />
        </g>
        <rect x="-14.5359" y="22.3008" width="44.9737" height="25.3884" rx="2.17615" fill="#E7E9F9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3468 31.915C10.7233 31.915 11.0314 32.2231 11.0314 32.5996V37.3915C11.0314 37.768 10.7233 38.0761 10.3468 38.0761H5.55492C5.17841 38.0761 4.87036 37.768 4.87036 37.3915V32.5996C4.87036 32.2231 5.17841 31.915 5.55492 31.915H10.3468ZM7.6086 36.5392L6.7529 35.509L5.55492 37.0492H10.3468L8.80658 34.9956L7.6086 36.5392Z"
          fill="#F3F4FC"
        />
        <rect x="-14.5359" y="51.3164" width="44.9737" height="3.62691" rx="1.81345" fill="#E7E9F9" />
        <rect x="-14.5359" y="57.1191" width="31.3186" height="3.62691" rx="1.81345" fill="#E7E9F9" />
        <path
          d="M-107.022 124.402C-107.022 124.148 -106.816 123.942 -106.563 123.942H131.895C132.148 123.942 132.354 124.148 132.354 124.402V125.36H-107.022V124.402Z"
          fill="#A3ACB1"
        />
        <path
          d="M-107.022 124.402C-107.022 124.148 -106.816 123.942 -106.563 123.942H131.895C132.148 123.942 132.354 124.148 132.354 124.402V125.36H-107.022V124.402Z"
          fill="url(#paint0_linear_3361_120304)"
        />
        <path
          d="M-107.022 125.36H132.354L127.167 126.401C121.22 127.594 115.169 128.195 109.103 128.195H-84.1689C-90.8353 128.195 -97.4819 127.47 -103.991 126.03L-107.022 125.36Z"
          fill="#647279"
        />
        <path
          d="M-107.022 125.36H132.354L127.167 126.401C121.22 127.594 115.169 128.195 109.103 128.195H-84.1689C-90.8353 128.195 -97.4819 127.47 -103.991 126.03L-107.022 125.36Z"
          fill="url(#paint1_linear_3361_120304)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-4.89941 123.942C-4.77721 124.734 -5.36986 125.36 -3.48235 125.36H29.0519C30.9394 125.36 30.3468 124.734 30.469 123.942H-4.89941Z"
          fill="#96A1A8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-4.89941 123.942C-4.77721 124.734 -5.36986 125.36 -3.48235 125.36H29.0519C30.9394 125.36 30.3468 124.734 30.469 123.942H-4.89941Z"
          fill="url(#paint2_linear_3361_120304)"
        />
      </g>
      <circle cx="73.25" cy="84.7812" r="25.4844" stroke="url(#paint3_linear_3361_120304)" strokeWidth="2.5" />
      <circle cx="73.25" cy="84.7812" r="23.7344" fill="#E7E9F9" stroke="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.4367 91.4757C82.9294 89.6524 83.825 87.3214 83.825 84.7813C83.825 78.9408 79.0904 74.2063 73.25 74.2063C67.4096 74.2063 62.675 78.9408 62.675 84.7813C62.675 87.3214 63.5706 89.6524 65.0633 91.4756C65.8375 89.2286 67.9704 87.6143 70.4803 87.6143H76.0196C78.5296 87.6143 80.6625 89.2286 81.4367 91.4757ZM81.6935 94.9524C84.6111 92.5277 86.4688 88.8714 86.4688 84.7813C86.4688 77.4807 80.5505 71.5625 73.25 71.5625C65.9495 71.5625 60.0312 77.4807 60.0312 84.7813C60.0312 88.8714 61.8889 92.5276 64.8065 94.9523C64.8065 94.9528 64.8066 94.9532 64.8066 94.9537C67.0966 96.8567 70.0396 98.001 73.2498 98.001C76.4602 98.001 79.4033 96.8565 81.6933 94.9533C81.6934 94.953 81.6934 94.9527 81.6935 94.9524ZM73.2503 85.7261C75.8576 85.7261 77.9713 83.6125 77.9713 81.0052C77.9713 78.3978 75.8576 76.2842 73.2503 76.2842C70.643 76.2842 68.5293 78.3978 68.5293 81.0052C68.5293 83.6125 70.643 85.7261 73.2503 85.7261Z"
        fill="#D7D9E7"
      />
      <path
        d="M57.0164 88H55.4164L58.1164 81H59.6264L62.3664 88H60.7464L60.2464 86.69V86.71H57.4964V86.69L57.0164 88ZM58.8764 82.64L57.9164 85.44H59.8064L58.8764 82.64ZM63.6103 85.42C63.6103 85.8467 63.7269 86.2 63.9603 86.48C64.2003 86.76 64.5236 86.9 64.9303 86.9C65.3169 86.9 65.6369 86.7767 65.8903 86.53C66.1436 86.2833 66.2703 85.94 66.2703 85.5C66.2703 85.0267 66.1436 84.6533 65.8903 84.38C65.6369 84.1067 65.3036 83.97 64.8903 83.97C64.4969 83.97 64.1836 84.11 63.9503 84.39C63.7236 84.6633 63.6103 85.0067 63.6103 85.42ZM66.2303 80.77H67.7203V88H66.2303V87.25C65.8303 87.8233 65.2936 88.11 64.6203 88.11C63.8603 88.11 63.2536 87.8533 62.8003 87.34C62.3469 86.8267 62.1203 86.1833 62.1203 85.41C62.1203 84.6567 62.3369 84.0267 62.7703 83.52C63.2103 83.0133 63.8169 82.76 64.5903 82.76C64.9236 82.76 65.2336 82.8333 65.5203 82.98C65.8136 83.1267 66.0503 83.3233 66.2303 83.57V80.77ZM73.7521 82.87L71.6121 88H70.1321L67.9821 82.87H69.6121L70.8621 86.33L72.1221 82.87H73.7521ZM75.5084 88H74.0184V82.87H75.5084V88ZM73.8384 81.51C73.8384 81.2567 73.9251 81.0533 74.0984 80.9C74.2717 80.74 74.4984 80.66 74.7784 80.66C75.0451 80.66 75.2684 80.74 75.4484 80.9C75.6351 81.0533 75.7284 81.2567 75.7284 81.51C75.7284 81.75 75.6351 81.95 75.4484 82.11C75.2684 82.2633 75.0451 82.34 74.7784 82.34C74.5051 82.34 74.2784 82.2633 74.0984 82.11C73.9251 81.9567 73.8384 81.7567 73.8384 81.51ZM76.7709 87.35C76.2509 86.8433 75.9909 86.2033 75.9909 85.43C75.9909 84.6567 76.2509 84.02 76.7709 83.52C77.2976 83.0133 77.9942 82.76 78.8609 82.76C79.5742 82.76 80.2742 83.0133 80.9609 83.52L80.2809 84.61C79.9009 84.27 79.4509 84.1 78.9309 84.1C78.4909 84.1 78.1376 84.2233 77.8709 84.47C77.6109 84.71 77.4809 85.03 77.4809 85.43C77.4809 85.83 77.6109 86.1533 77.8709 86.4C78.1376 86.64 78.4909 86.76 78.9309 86.76C79.4509 86.76 79.9009 86.59 80.2809 86.25L80.9609 87.34C80.2742 87.8467 79.5742 88.1 78.8609 88.1C77.9942 88.1 77.2976 87.85 76.7709 87.35ZM83.7208 83.97C83.4408 83.97 83.1742 84.0433 82.9208 84.19C82.6742 84.3367 82.5075 84.5667 82.4208 84.88H84.9908C84.9442 84.58 84.7942 84.3533 84.5408 84.2C84.2875 84.0467 84.0142 83.97 83.7208 83.97ZM85.3808 86.28L86.2408 87.1C85.6342 87.7733 84.8375 88.11 83.8508 88.11C82.9308 88.11 82.2108 87.86 81.6908 87.36C81.1708 86.8533 80.9108 86.22 80.9108 85.46C80.9108 84.7 81.1775 84.06 81.7108 83.54C82.2442 83.02 82.9208 82.76 83.7408 82.76C84.5075 82.76 85.1608 83.0233 85.7008 83.55C86.2475 84.0767 86.5208 84.82 86.5208 85.78H82.3908C82.4042 86.1067 82.5508 86.3733 82.8308 86.58C83.1108 86.7867 83.4875 86.89 83.9608 86.89C84.4875 86.89 84.9608 86.6867 85.3808 86.28ZM89.3929 85.67H88.0029C88.0029 85.3033 88.0429 85.0267 88.1229 84.84C88.2029 84.6533 88.4063 84.4567 88.7329 84.25C89.1196 84.0033 89.3963 83.79 89.5629 83.61C89.7296 83.43 89.8129 83.2133 89.8129 82.96C89.8129 82.7133 89.7263 82.52 89.5529 82.38C89.3796 82.2333 89.1629 82.16 88.9029 82.16C88.6563 82.16 88.4463 82.2267 88.2729 82.36C88.0996 82.4867 88.0129 82.6633 88.0129 82.89C88.0129 83.01 88.0563 83.1767 88.1429 83.39H86.7229C86.6296 83.21 86.5829 82.9933 86.5829 82.74C86.5829 82.28 86.7863 81.8567 87.1929 81.47C87.5996 81.0833 88.1696 80.89 88.9029 80.89C89.6096 80.89 90.1863 81.0767 90.6329 81.45C91.0796 81.8233 91.3029 82.3167 91.3029 82.93C91.3029 83.3767 91.1629 83.7733 90.8829 84.12C90.6096 84.4667 90.1629 84.8333 89.5429 85.22C89.4429 85.28 89.3929 85.4 89.3929 85.58V85.67ZM87.7629 87.25C87.7629 86.9967 87.8496 86.7867 88.0229 86.62C88.2029 86.4533 88.4296 86.37 88.7029 86.37C88.9696 86.37 89.1929 86.4533 89.3729 86.62C89.5596 86.7867 89.6529 86.9967 89.6529 87.25C89.6529 87.4967 89.5596 87.7033 89.3729 87.87C89.1929 88.03 88.9696 88.11 88.7029 88.11C88.4296 88.11 88.2029 88.03 88.0229 87.87C87.8496 87.7033 87.7629 87.4967 87.7629 87.25Z"
        fill="#1C1C21"
      />
      <defs>
        <filter
          id="filter0_d_3361_120304"
          x="-130.597"
          y="-20.8703"
          width="286.526"
          height="181.345"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.70458" />
          <feGaussianBlur stdDeviation="11.7875" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3361_120304" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3361_120304" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_3361_120304"
          x1="-107.022"
          y1="124.651"
          x2="132.354"
          y2="124.651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1012" />
          <stop offset="0.0295345" stopColor="#CAD4DB" />
          <stop offset="0.0625" stopColor="#242729" />
          <stop offset="0.133609" stopColor="#A3ACB1" />
          <stop offset="0.865967" stopColor="#A3ACB1" />
          <stop offset="0.941937" stopColor="#242729" />
          <stop offset="0.971275" stopColor="#CAD4DB" />
          <stop offset="0.996436" stopColor="#0D1012" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3361_120304"
          x1="12.666"
          y1="125.36"
          x2="12.666"
          y2="128.195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A7F83" />
          <stop offset="1" stopColor="#0B0B0E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3361_120304"
          x1="-3.12611"
          y1="124.803"
          x2="29.4081"
          y2="124.803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C3C3C" />
          <stop offset="0.317518" stopColor="#3C3C3C" stopOpacity="0" />
          <stop offset="0.660584" stopColor="#3C3C3C" stopOpacity="0" />
          <stop offset="1" stopColor="#444444" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3361_120304"
          x1="52.0911"
          y1="63.0198"
          x2="94.6412"
          y2="108.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E05FE" />
          <stop offset="0.591773" stopColor="#FF0066" />
          <stop offset="1" stopColor="#FFB13F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BubbleConfigHintImage;
